// extracted by mini-css-extract-plugin
export default {"viewMore":"qJUek","reviewsCount":"WxNob","review":"r_I7h","viewMoreContainer":"qtmvh","reviewsProgress":"_sR12","spinner":"wVnTh"};